/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// Прости, боже ↑
import type { FC } from 'react';
import { cloneElement } from 'react';
import flattenChildren from 'react-keyed-flatten-children';

import useTypograph from '../../../hooks/useTypograph';

interface Props {
  children:
    | JSX.Element
    | string
    | null
    | boolean
    | (string | null | boolean | JSX.Element)[];
}

function useTypography(): (item: any) => any {
  const typograph = useTypograph();

  function t(item: any): any {
    if (Array.isArray(item)) {
      return item.map(child => t(child));
    }

    if (typeof item === 'string') {
      if (item === ' ') {
        return item;
      }

      return typograph(item);
    } else if (item.props.children) {
      return cloneElement(item, {
        children: flattenChildren(item.props.children).map(child => t(child)),
      });
    } else {
      return item;
    }
  }

  return t;
}

const Typograf: FC<Props> = ({ children }) => {
  const t = useTypography();

  return t(flattenChildren(children));
};

export default Typograf;
